import * as React from 'react';
import { classNames, UitkContextProvider } from 'uitk-react-utils';
import styles from './uitk-banner.css';

var getClassNameList = classNames.bind(styles);
var UitkBanner = function (props) {
    var _a;
    var children = props.children, fullWidth = props.fullWidth, theme = props.theme;
    var baseClass = 'uitk-banner';
    var wrapperClassNames = getClassNameList(baseClass, (_a = {},
        _a["".concat(baseClass, "-full-width")] = fullWidth,
        _a["".concat(baseClass, "-").concat(theme)] = theme,
        _a));
    return children ? (React.createElement("div", { className: wrapperClassNames },
        React.createElement(UitkContextProvider, { config: {
                context: null,
                data: {
                    contextClassNames: {
                        UitkHeading: "".concat(getClassNameList('uitk-banner-header')),
                        UitkText: "".concat(getClassNameList('uitk-banner-description')),
                        UitkIcon: "".concat(getClassNameList('uitk-banner-icon')),
                        UitkLink: "".concat(getClassNameList('uitk-banner-link'))
                    }
                }
            } }, children))) : null;
};
UitkBanner.displayName = 'UitkBanner';
UitkBanner.defaultProps = {
    theme: 'critical'
};

export { UitkBanner };
